import { Component, Inject, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { OKTA_AUTH, OktaAuthStateService } from '../../../node_modules/@okta/okta-angular';
import { Tokens, OktaAuth } from '../../../node_modules/@okta/okta-auth-js';
import * as OktaSignIn from '@okta/okta-signin-widget';
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Component({
    selector: 'app-okta-widget',
    standalone: true,
    templateUrl: './okta-widget.component.html',
    styleUrls: ['./okta-widget.component.scss'],
})
export class OktaWidgetComponent implements OnInit {
    authService;

    signInWidgetConfig = {
        // Enable or disable widget functionality with the following options. Some of these features require additional configuration in your Okta admin settings. Detailed information can be found here: https://github.com/okta/okta-signin-widget#okta-sign-in-widget
        // Look and feel changes:
        //logo: '//logo.clearbit.com/okta.com', // Try changing "okta.com" to other domains, like: "workday.com", "splunk.com", or "delmonte.com"
        language: 'en', // Try: [fr, de, es, ja, zh-CN] Full list: https://github.com/okta/okta-signin-widget#language-and-text
        i18n: {
            //Overrides default text when using English. Override other languages by adding additional sections.
            en: {
                'primaryauth.title': 'Sign In', // Changes the sign in text
                'primaryauth.submit': 'Sign In', // Changes the sign in button
                // More e.g. [primaryauth.username.placeholder,  primaryauth.password.placeholder, needhelp, etc.].
                'primaryauth.username.tooltip': 'Producers enter username. Customers enter email.',
                'password.forgot.email.or.username.placeholder': 'Email or Username',
                'password.forgot.email.or.username.tooltip': 'Producers enter username. Customers enter email.',
                // Full list here: https://github.com/okta/okta-signin-widget/blob/master/packages/@okta/i18n/dist/properties/login.properties
            },
        },
        // Changes to widget functionality
        features: {
            registration: false, // Enable self-service registration flow
            rememberMe: false, // Setting to false will remove the checkbox to save username
            //multiOptionalFactorEnroll: true,  // Allow users to enroll in multiple optional factors before finishing the authentication flow.
            selfServiceUnlock: true, // Will enable unlock in addition to forgotten password
            smsRecovery: true, // Enable SMS-based account recovery
            //callRecovery: true,               // Enable voice call-based account recovery
            //router: true, // Leave this set to true for the API demo,
            passwordlessAuth: this.config.passwordlessAuth,
        },
        customButtons: [
            {
                title: 'Don’t have an Account? ',
                className: 'btn-reset',
                click() {
                    return false;
                },
            },
            {
                title: 'Producer Signup',
                className: 'btn-reset btn-signup',

                click: () => {
                    window.location.href = `${this.config.appURL}/login`;
                },
            },
            {
                title: 'Customer Signup',
                className: 'btn-reset btn-signup',

                click: () => {
                    window.location.href = `${this.config.appURL}/login`;
                },
            },
        ],
        baseUrl: this.config.okta.baseURL,
        authParams: {
            pkce: true,
            issuer: this.config.okta.issuer,
            scopes: this.config.okta.scopes,
        },
        clientId: this.config.okta.clientId,
        redirectUri: `${this.config.appURL}/implicit/callback`,
        el: '#widget-container',
    };

    signIn = new OktaSignIn(this.signInWidgetConfig);

    constructor(
        @Inject(OKTA_AUTH) oktaAuth: OktaAuth,
        private router: Router,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {
        this.authService = oktaAuth;

        // Show the widget when prompted, otherwise remove it from the DOM.
        router.events.forEach((event) => {
            if (event instanceof NavigationStart) {
                switch (event.url) {
                    case '/login':
                        break;
                    case '/protected':
                        break;
                    default:
                        this.signIn.remove();
                        break;
                }
            }
        });
    }

    async ngOnInit() {
        const originalUri = this.authService.getOriginalUri();
        if (!originalUri) {
            this.authService.setOriginalUri('/');
        }

        const tokens: Tokens = await this.signIn.showSignInToGetTokens({
            el: '#widget-container',
        });
        this.authService.handleLoginRedirect(tokens);
        this.signIn.hide();
        let isAuthenticated = await this.authService.isAuthenticated();
        if (isAuthenticated) {
            this.router.navigate(['/policy360']);
        }
    }
}
